import { SpinResponse } from '@cgs/data-access';
import { LazyAction } from '@cgs/shared';
import { Action, Container, EmptyAction, SequenceSimpleAction } from '@cgs/wge';
import { EpicWinStepName } from '../../../components/epic_win/epic_win_step';
import { AwaitableAction } from '../../../../reels_engine/actions/awaitable_action';
import {
  GAME_STATE_MACHINE_PROVIDER_TOKEN,
  IGameStateMachineProvider,
} from '../../../../reels_engine/game_components_providers/i_game_state_machine_provider';
import { GameStateMachine } from '../../../../reels_engine/state_machine/game-state-machine';
import { EpicWinConfiguration } from '../../../components/epic_win/epic_win_configuration';
import { EpicWinPopupView } from '../views/epic_win_popup_view';
import { BaseSlotPopupController } from './base_popup_controller';

export class EpicWinPopupController extends BaseSlotPopupController<EpicWinPopupView> {
  protected readonly gameStateMachine: GameStateMachine<SpinResponse>;
  protected configuration: EpicWinConfiguration;
  protected lazyAction: Action;

  private readonly _startAfterShortWinLines: boolean = false;

  get bigWinName(): EpicWinStepName {
    return this.gameStateMachineNotifier.gameStateMachine.curResponse.bigWinName
      .replaceAll(' ', '')
      .toLowerCase() as EpicWinStepName;
  }

  constructor(
    container: Container,
    popupView: EpicWinPopupView,
    configuration: EpicWinConfiguration,
    stopBackgroundSound: boolean,
    startAfterShortWinLines: boolean
  ) {
    super(container, popupView, stopBackgroundSound);
    this.configuration = configuration;
    this.gameStateMachine = container.resolve<IGameStateMachineProvider>(
      GAME_STATE_MACHINE_PROVIDER_TOKEN
    ).gameStateMachine;
    this._startAfterShortWinLines = startAfterShortWinLines;
    this.initSubscriptions();
  }

  protected initSubscriptions(): void {
    this.lazyAction = new LazyAction(() =>
      this.popupAction(this.gameStateMachineNotifier.gameStateMachine.curResponse)
    );

    const state = this._startAfterShortWinLines
      ? this.gameStateMachineNotifier.gameStateMachine.shortWinLines
      : this.gameStateMachineNotifier.gameStateMachine.animation;

    state.appendLazyAnimation(() => this.lazyAction);
  }

  protected onPopupClosed(): void {
    if (!this.lazyAction.isFinished) {
      this.lazyAction.end();
    }

    super.onPopupClosed();
  }

  protected popupAction(response: SpinResponse): Action {
    if (!this.isBigWin(response)) {
      return new EmptyAction();
    }

    return new SequenceSimpleAction([
      this.view.showWinAction(this.bigWinName, this.gameStateMachine.curResponse.totalWin),
      new AwaitableAction(this.view.show()),
    ]);
  }

  protected isBigWin(response: SpinResponse): boolean {
    return !!(
      response.bigWinName &&
      this.configuration.steps.find((step) => step.winName === this.bigWinName)
    );
  }
}
